import React from 'react';
import { FadeIn } from './FadeIn';
export function BonusesSection() {
  const bonuses = [{
    title: 'BONO 1: Reset Digestivo (Reinicio Total)',
    description: 'Desinflamá tu cuerpo en 14 días.',
    value: '$22.000'
  }, {
    title: 'BONO 2: Desayunos Express',
    description: 'Mañanas de 2 minutos sin ensuciar nada.',
    value: '$12.000'
  }, {
    title: 'BONO 3: Postres de Freezer',
    description: 'Snacks dulces y saludables siempre listos.',
    value: '$10.000'
  }, {
    title: 'BONO 4: Smart-Shopper',
    description: 'Calculadora de ahorro y ruta mayorista.',
    value: '$8.000'
  }];
  return <section className="bg-gray-900 py-10 md:py-16 px-4 md:px-8 text-white" data-id="element-22">
      <div className="max-w-6xl mx-auto" data-id="element-23">
        <FadeIn data-id="element-24">
          <h2 className="text-3xl md:text-5xl font-bold text-center mb-6 md:mb-10 text-[#FF9F43]" data-id="element-25">
            BONOS EXCLUSIVOS
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-6" data-id="element-26">
          {bonuses.map((bonus, index) => <FadeIn key={index} delay={0.1 * index} className="bg-gray-800 border-2 border-[#FF9F43] p-4 md:p-8 rounded-2xl relative overflow-hidden" data-id="element-27">
              <div className="absolute top-0 right-0 bg-[#FF9F43] text-gray-900 font-bold py-1 px-4 rounded-bl-xl" data-id="element-28">
                ¡GRATIS!
              </div>
              <div className="text-2xl md:text-3xl mb-2 md:mb-4" data-id="element-29">🎁</div>
              <h3 className="text-xl md:text-2xl font-bold mb-3" data-id="element-30">
                {bonus.title}
              </h3>
              <p className="text-gray-300 text-lg mb-4" data-id="element-31">{bonus.description}</p>
              <p className="text-sm text-gray-400" data-id="element-32">
                Valor normal:{' '}
                <span className="line-through" data-id="element-33">{bonus.value}</span>
              </p>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}